import { Image } from '@enterprise-ui/canvas-ui-react';

import storeImg from '../../common/graphics/calibration-store.svg?url';
import outsideImg from '../../common/graphics/calibration-outside.svg?url';
import insideImg1 from '../../common/graphics/wall-A1.svg?url';
import insideImg3 from '../../common/graphics/wall-B3.svg?url';
import outsideImg2 from '../../common/graphics/wall-D2.svg?url';
import outsideImg4 from '../../common/graphics/wall-C4.svg?url';
import atrGif from '../../common/graphics/ATR_FOUR_QUADS.gif';
import correctExitImg from '../../common/graphics/CONFIRM_POSITION_1.svg?url';
import wrongExitImg from '../../common/graphics/CONFIRM_POSITION_2.svg?url';
import correctStoreImg from '../../common/graphics/CONFIRM_POSITION_3.svg?url';
import wrongStoreImg from '../../common/graphics/CONFIRM_POSITION_4.svg?url';
import exit4ftImg from '../../common/graphics/CONFIRM_READER_DISTANCE_1.svg?url';
import store4ftImg from '../../common/graphics/CONFIRM_READER_DISTANCE_2.svg?url';
import quadImgA from '../../common/graphics/QUAD_A.svg?url';
import quadImgB from '../../common/graphics/QUAD_B.svg?url';
import quadImgC from '../../common/graphics/QUAD_C.svg?url';
import quadImgD from '../../common/graphics/QUAD_D.svg?url';
import atrSwapImg from '../../common/graphics/SWAP_READER_SIDES_ATR.svg?url';

export const RfidGraphic = ({ placement, variant }) => {
  const imageSelector = (placement) => {
    switch (placement) {
      case 'INSIDE':
        return storeImg;
      case 'OUTSIDE':
        return outsideImg;
      case 'INSIDE_1':
        return insideImg1;
      case 'INSIDE_3':
        return insideImg3;
      case 'OUTSIDE_2':
        return outsideImg2;
      case 'OUTSIDE_4':
        return outsideImg4;
      case 'ATR_INTRO_GIF':
        return atrGif;
      case 'ATR_EXIT_CORRECT':
        return correctExitImg;
      case 'ATR_STORE_CORRECT':
        return correctStoreImg;
      case 'ATR_EXIT_WRONG':
        return wrongExitImg;
      case 'ATR_STORE_WRONG':
        return wrongStoreImg;
      case 'ATR_4FT_EXIT':
        return exit4ftImg;
      case 'ATR_4FT_STORE':
        return store4ftImg;
      case 'QUAD_B':
        return quadImgB;
      case 'QUAD_A':
        return quadImgA;
      case 'QUAD_D':
        return quadImgD;
      case 'QUAD_C':
        return quadImgC;
      case 'ATR_SWAP_SIDES':
        return atrSwapImg;
      default:
        return;
    }
  };

  return (
    <div className="rfid-wrapper">
      {variant === 'portrait' ? (
        <Image
          className="rfid-calibration-graphic"
          src={imageSelector(placement)}
          alt="Calibration illustration"
          width="350px"
          height="450px"
          type="contain"
        />
      ) : (
        <Image
          className="rfid-calibration-graphic"
          src={imageSelector(placement)}
          alt="Calibration illustration"
          width="300px"
          height="300px"
          type="contain"
        />
      )}
    </div>
  );
};
